<template>
  <div>
    <v-app>
      <v-navigation-drawer
        v-model="drawer"
        clipped
        fixed
        app>
        <v-list dense >
          <v-list-tile v-for="item in menuList" :key="item.key"
                       @click="menuEvent(item.key, item.path)">
            <v-list-tile-content>
              <v-list-tile-title :style="{color:item.color}">{{item.label}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-navigation-drawer>
      <v-toolbar app fixed clipped-left dark class="primary">
        <v-toolbar-side-icon class="white--text"
                             @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="title white--text">數位線上資融進件平台 v{{ getVersion }}</v-toolbar-title>
        <v-spacer></v-spacer>
<!--        <span class="title">{{getUserInfo.displayName}}</span>-->

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              {{getUserInfo.displayName}}
            </v-btn>
          </template>
          <v-list>
            <v-list-tile>
              <v-list-tile-title v-on:click="showLineAuth">開啟Line通知</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <v-content class="overflow-main">
        <router-view></router-view>
      </v-content>

      <alert-view :visible="messageDialog.visible" :title="messageDialog.title" :is-persistent="true"
                  :show-cancel="messageDialog.showCancelButton"
      :content="messageDialog.text" @confirmEvent="confirmEvent"
                  @cancelEvent="cancelEvent"></alert-view>
    </v-app>

  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AlertView from '@/components/AlertView';
import NoticeManager from '@/utils/notice_manager';
import common from '@/mixins/common';
import { checkVersion, verifyToken } from '@/store/actions';

export default {
  name: 'Navigation',
  components: { AlertView },
  data() {
    return {
      drawer: false,
      messageDialog: {
        title: '',
        text: '',
        visible: false,
        showCancelButton: false,
        confirm: () => {
        },
        cancel: () => {
        },
      },
      task: null,
    };
  },
  created() {
    NoticeManager.addObserver('showAlert', (dialog)=>{
      this.messageDialog = dialog;
    });
    this.check();
  },
  mixins:[common],
  computed: {
    ...mapGetters(['getUserInfo']),
    menuList() {
      const pathString = `EditCreditProduct?caseCategory=${3}&editIndex=-1&agentId=${this.getUserInfo.agentId}`;
      const menuList = [
        { key: 'NoticeList', path: '/home/NoticeList', label: '公告重要事項' ,color:'red'},
        { key: 'RequestPaymentView', path: '/home/RequestPaymentView', label: '每日待撥清單' },
        { key: 'AppropriationEditView', path: '/home/AppropriationEditView', label: '設定撥款明細' },
        { key: 'FinanceInsureList', path: '/home/FinanceInsureList', label: '對保費管理' },
        { key: 'FileList', path: '/home/FileList', label: '各式資料表單' },
        { key: 'ReportChart', path: '/home/ReportChart', label: '統計通路報表' },


        // { key: 'AgentCaseCount', path: '/home/agentCaseCount', label: '經銷進件統計' },
        // { key: 'GrantNoticeView', path: '/home/GrantNoticeView', label: '優撥清單' },
        { key: '#1', path: '', label: '-----------' },
        { key: 'CCHFinanceList', path: '/home/CCHFinanceList', label: '嘉好案件管理' },
        { key: 'GooddealList', path: '/home/GooddealList', label: '賀丞交案件管理' },
        { key: 'home', path: '/home/index', label: '裕富原車進件管理' },
        { key: 'CAFinanceList', path: '/home/CAFinanceList', label: '裕富機車N進件管理' },
        { key: 'EntrepreneurCreditList', path: '/home/EntrepreneurCreditList', label: '中租進件管理' },
        { key: 'LoanhfcCreditList', path: '/home/LoanhfcCreditList', label: '和潤進件管理' },
        { key: 'EditCreditProduct', path: pathString, label: '後台進件管理' },
        { key: 'CCH21FinanceList', path: '/home/CCH21FinanceList', label: '21世紀進件管理' },
        { key: 'CreditLoanList', path: '/home/CreditLoanList', label: '信貸管理' },
        { key: 'LoanhfcCarFinanceList', path: '/home/LoanhfcCarFinanceList', label: '和潤汽車管理' },
        { key: 'ChaileaseList', path: '/home/ChaileaseList', label: '中租汽車管理' },
        { key: 'TACFinanceList', path: '/home/TACFinanceList', label: 'TAC汽車管理' },
        { key: 'MergePdfView', path: '/home/MergePdfView', label: '合併PDF工具' },

        { key: '#2', path: '', label: '-----------' },
        { key: 'CompanyDocList', path: '/home/CompanyDocList', label: '獎金.支出.收入證明單' },
        { key: 'AgentContractToolView', path: '/home/ContractToolView', label: '代辦合約書' },
        { key: 'MortgageList', path: '/home/MortgageList', label: '動產抵押管理' },
        { key: 'TradeCarList', path: '/home/TradeCarList', label: '通路拉車過戶公司車歸列檔案' },
        { key: 'InstallmentReplyView', path: '/home/InstallmentReplyView', label: '裕富申覆管理' },
        { key: 'AccountReportView', path: '/home/AccountReportView', label: '帳務報表管理' },
        { key: 'Agent', path: '/home/agent', label: '經銷業務管理' },
        { key: 'assignorList', path: '/home/assignorList', label: '讓與人管理' },
        { key: 'InstallmentPaymentView', path: '/home/InstallmentPaymentView', label: '裕富請款管理' },
        { key: 'InsureAgentList', path: '/home/InsureAgentList', label: '對保資料管理' },
        { key: 'CCH_PAY', path: '#', label: '金流系統' },

        // { key: '#3', path: '', label: '-----------' },

        // { key: 'CashFlowView', path: '/home/CashFlowView', label: '銀行帳戶管理' },
        // { key: 'RectifierManagerView', path: '/home/RectifierManagerView', label: '機車商品管理' },
        // { key: 'StockManagerView', path: '/home/StockManagerView', label: '商品庫存管理' },
        // { key: 'DeliveryNoteList', path: '/home/DeliveryNoteList', label: '商品訂單管理' },
        // { key: 'EngineSearchView', path: '/home/EngineSearchView', label: '引擎號碼查詢' },
        // { key: 'TCBPayment', path: '/home/TCBPayment', label: '收款工具' },
        { key: 'logout', path: '/login', label: '登出' },
      ];

      if (this.isMobile){
        menuList.splice(0, 0,  { key: 'SearchFinanceInfo', path: '/SearchFinanceInfo', label: '原融/CA 案件快速查詢'});
      }

      if (this.isAdmin){
        return menuList.filter(m=>m.key !== 'InsureAgentList');
      } else if (this.isManager){
        return menuList.filter(m=>m.key !== 'InsureAgentList');
      } else if (this.isInsureAgent){ // 派對
        return menuList.filter(m=>m.key === 'InsureAgentList');
      } else if (this.isStaff || this.isAccounting){
        return menuList.filter(m=>{
          if (m.key === 'CompanyDocList'){
            return this.getUserInfo.enableCompanyDoc;
          } else if (m.key !== 'CashFlowView' && m.key !== 'AccountReportView' && m.key !== 'CompanyDocList'){
            return true;
          }
        });
      }

      console.log(`this.getUserInfo.authority == ${this.getUserInfo.authority}`);

      if (!Object.keys(this.getUserInfo).length) {
        return menuList.filter(m=>m.key === 'EngineSearchView');
      }

      const otherMenu = menuList.filter(m=>{
        if (m.key === 'QuestionList'
          || m.key === 'ReportChart' || m.key === 'CashFlowView' || m.key === 'RectifierManagerView' || m.key === 'AgentCaseCount'
          || m.key === 'StockManagerView'
          || m.key === 'DeliveryNoteList' || m.key === 'CompanyDocList' || m.key === 'AppropriationEditView'
        || m.key === 'CCHFinanceList'|| m.key === 'LoanhfcCarFinanceList'|| m.key === 'ChaileaseList'|| m.key === 'TACFinanceList'
        || m.key === 'AccountReportView' || m.key ==='InstallmentPaymentView' || m.key ==='InsureAgentList'
          || m.key ==='AgentContractToolView' || m.key ==='AgentContractToolView'|| m.key ==='FinanceInsureList' || m.key ==='MortgageList'
        || m.key ==='assignorList' || m.key ==='CCH_PAY'){
          return false;
        }
        return true;
      });

      console.log(`otherMenu == ${otherMenu.length}`);

      return otherMenu.filter(m=>{
        if (this.getUserInfo.enableAdminFinance === true && (m.key === 'QuestionList' || m.key === 'ReportChart' || m.key === 'CashFlowView'
          || m.key === 'RectifierManagerView'
          || m.key === 'StockManagerView'
          || m.key === 'DeliveryNoteList')){
          return true;
        } else if (m.key === 'Agent'){
          return this.getUserInfo.enableAgent;
        } else if (m.key === 'home'){
          return this.getUserInfo.enableAdminFinance;
        } else if (m.key === 'InstallmentReplyView'){
          return this.getUserInfo.enableInstallmentReplyView;
        } else if (m.key === 'EntrepreneurCreditList'){
          return this.getUserInfo.enableEntrepreneurCreditList;
        } else if (m.key === 'LoanhfcCreditList'){
          return this.getUserInfo.enableLoanhfcCreditList;
        } else if (m.key === 'CAFinanceList'){
          return this.getUserInfo.enableCaList;
        } else if (m.key === 'CreditLoanList'){
          return this.getUserInfo.enableCreditLoanList;
        } else if (m.key === 'EditCreditProduct'){
          return this.getUserInfo.enableEditCreditProduct;
        } else if (m.key === 'TCBPayment'){
          return this.getUserInfo.enablePaymentTool;
        } else if (m.key === 'GooddealList'){
          return this.getUserInfo.enableGooddealList;
        } else if (m.key === 'RequestPaymentView'){
          return this.getUserInfo.enablePaymentView;
        } else {
          return true;
        }
      })
    },
  },
  methods: {
    ...mapActions(['logOut','checkVersion', 'verifyToken', 'saveAgent']),
    async check(){
      console.log(`this.getUserInfo.token = ${this.getUserInfo.token}`);

      await this.checkCurrentVersion();
      const self = this;
      if (this.task == null){
        this.task = setInterval(async ()=>{
          await self.checkCurrentVersion();
          if (this.getUserInfo.token && this.getUserInfo.enableToken === true){
            await self.checkToken();
          }
        }, 5 * 60 * 1000);
      }
    },
    async checkCurrentVersion(){
      const res = await this.checkVersion({
        version: this.getVersion
      });
      const result = res.data;
      if (result){
        console.log(`checkVersion == ${JSON.stringify(result)}`);
        localStorage.setItem('maintain', result.data.maintain === true ? 1 : 0);
        if (result.data.update === true){
          console.log(`==版本過舊提示更新==`);
          if (this.messageDialog.visible === false){
            this.showMessageDialog('提示','目前有新版本，請重新整理！', true, ()=>{
              location.reload();
            });
          }
        } else {
          console.log(`==最新版不需更新==`);
        }
      }
    },
    async checkToken(){
      const userInfo = this.getUserInfo;
      if (!userInfo){
        return;
      }
      try {
        if (!this.getUserInfo.token || this.getUserInfo.token === ''){
          return;
        }
        const res = await this.verifyToken({ token: this.getUserInfo.token });
        if (res.status === 200){
          const result = res.data;
          console.log(`checkToken 有效 = ${JSON.stringify(result)}`);
        } else {
          console.log(`checkToken 失效`);
          userInfo.enableToken = false;
          userInfo.token = '';
          this.saveAgent(userInfo);
          this.showMessageDialog('提示','檢視權限已過期，請聯絡管理者延長時效！', true, ()=>{
            location.reload();
          });
        }
      } catch (e) {
        // 失效
        console.log(`checkToken 失效`);
        userInfo.enableToken = false;
        userInfo.token = '';
        this.saveAgent(userInfo);
        this.showMessageDialog('提示','檢視權限已過期，請聯絡管理者延長時效！', true, ()=>{
          location.reload();
        });
      }
    },
    menuEvent(key, path) {
      if (key.indexOf('#') > -1){
        return;
      }

      if (key === 'SearchFinanceInfo'){
        const {href} = this.$router.resolve({
          name: 'SearchFinanceInfo',
        })
        window.open(href, '_blank');
        return;
      }

      if (key === 'CCH_PAY'){
        window.open('https://cchpay.haorich.tw/', '_blank');
      }

      if (key === 'logout') {
        this.logOut();
      }
      this.$router.push(path);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    confirmEvent(){
      this.messageDialog.visible = false;
      NoticeManager.notifyObservers('alertConfirm');
    },
    cancelEvent(){
      this.messageDialog.visible = false;
      NoticeManager.notifyObservers('alertCancel');
    },
    showLineAuth(){
      window.open(`https://haorich.tw/line/authorize/?state=${this.getUserInfo.agentId}`, '_blank');
    }
  },
};
</script>

<style scoped>
  .overflow-main {
    overflow-y: auto;
    padding: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Navigation.vue